import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <span>Welcome to xynectics</span>
      </header>
    </div>
  );
}

export default App;
